  import React, { useEffect, useRef, useState } from "react";
  import { useDispatch } from "react-redux";
  import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
  import {
    AlignHorizontalJustifyStart,
    AlignHorizontalJustifyEnd,
    AlignVerticalJustifyStart,
    AlignVerticalJustifyEnd,
    AlignHorizontalSpaceBetween,
    AlignHorizontalSpaceAround,
   
    AlignHorizontalJustifyCenter,
    AlignHorizontalDistributeCenter,
    AlignVerticalJustifyCenter,
    AlignVerticalDistributeCenter,
    AlignVerticalSpaceBetween,
    Hash,
    Frame,
    ChevronUp,
    ChevronDown,
  } from "lucide-react";
  import {
    AlignVerticalSpaceAround,
    AlignVerticalJustifyStretch,
  } from "lucide-react";
import RangeSliderDynamic from "../../../UI/RangeSliderDynamic";
  const ItemPaddingUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
   
  
       const dispatch = useDispatch();  
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
              {
                
                dispatch({type: "CURSOR",payload:true  });
            
                dispatch({type: "CURSORTEXT",payload:CursorText})
                dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
              }
               
              const handleMouseLeave = () => {
                
                dispatch({type: "CURSOR",payload:false})
            
                dispatch({type: "CURSORTEXT",payload:""})
            
                dispatch({type: "CURSORTEXTBG",payload:""})
                dispatch({type: "CURSORTEXTCOLOR",payload:""})
              
            
            }
   const [itemValue, setItemValue] = useState(objectValue);
  
  const [paddingVerticalBoth, setPaddingVerticalBoth] = useState(false);
  
const [paddingTop, setPaddingTop] = useState(objectValue?.paddingTop);
const [paddingBottom, setPaddingBottom] = useState(objectValue?.paddingBottom);
const [paddingLeft, setPaddingLeft] = useState(objectValue?.paddingLeft);
const [paddingRight, setPaddingRight] = useState(objectValue?.paddingRight);
   return(<>
  <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",position:"relative"}}>
    
  <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"0px",paddingLeft:"5px",display:"flex",justifyContent:"space-between"}}>
                      <div style={{fontSize:"18px",fontWeight:"bold",padding:"0px",paddingTop:"-5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"space-between"}}>
              <h4>{displayName} </h4> </div> 
                 <div style={{marginTop:"10px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             {paddingVerticalBoth?<ChevronDown onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                       :<ChevronUp onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>}
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={paddingVerticalBoth?"yes":""}
                   className="input-textbox"  value={paddingVerticalBoth}  name={objectName}  
                   onChange={e=>{setPaddingVerticalBoth(e.target.checked);}}/>
                        <span class={"boxCardBorder-two"}></span> </label> </div></div>

       <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"0px",padding:"0px"}}>
  <div  style={{padding:"0px",}}>
                  <div  style={{border:"0px solid rgba(144, 202, 249,1)",}}>
                 {paddingVerticalBoth?<div className="colorPickerDynamic"  style={{position:"absolute",width:"320px",right:"0px",bottom:"80px",zIndex:"9999999",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)" ,border:"3px solid rgba(144, 202, 249,1)",background:"#fff",padding: "8px",paddingTop:"3px", borderRadius:"20px" }}>
                <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",paddingTop:"-5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"space-between"}}>
              <h4>{displayName} </h4> </div>
              {objectValue?.paddingTop?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}> <div style={{paddingTop:"0px"}}> <h4>Top Padding </h4></div> 
         <RangeSliderDynamic   rangeIntervalType="paddingTop" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setPaddingTop({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Top")}}  sliderVal={paddingTop?.value} />
      
           </div>:""}{objectValue?.paddingBottom?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}>  <div style={{paddingTop:"0px"}}><h4>Bottom Padding</h4></div>
           <RangeSliderDynamic   rangeIntervalType="paddingBottom" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setPaddingBottom({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Bottom")}}  sliderVal={paddingBottom?.value} />
       </div>:""}{objectValue?.paddingLeft?.value?
       <div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}> <div style={{paddingTop:"0px"}}><h4>Left Padding </h4></div>
        <RangeSliderDynamic   rangeIntervalType="paddingLeft" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setPaddingLeft({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Left")}}  sliderVal={paddingLeft?.value} />
          </div>:""}
          {objectValue?.paddingRight?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}>  <div style={{paddingTop:"0px"}}><h4>Right Padding</h4></div>
           <RangeSliderDynamic   rangeIntervalType="paddingRight" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setPaddingRight({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Right")}}  sliderVal={paddingRight?.value} />
       </div>:""}<div style={{background:"rgb(208, 234, 255)",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}>
                 <div style={{paddingTop:"0px",}}> <h4> Overall Padding </h4></div> 
               <RangeSliderDynamic   rangeIntervalType="layoutPadding" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setPaddingTop({value:value,resolution:"px"}) ;setPaddingBottom({value:value,resolution:"px"}) ;setPaddingLeft({value:value,resolution:"px"}) ;setPaddingRight({value:value,resolution:"px"}) ; callbackItemValue({value:value,resolution:"px"},objectName+"All")}}  sliderVal={paddingTop?.value} />
       </div></div>:"" }  
       
        </div> </div> </div>
          
                        </div>             
                                   </>)
  
      } 
      export default ItemPaddingUI;
  
                       
  
